<script lang="ts" setup>

	import FavoritesBackButton from '@/components/favorites/FavoritesBackButton.vue';
	import VarietyFiltersComponent from '@/components/filters/VarietyFiltersComponent.vue';
	import {useFavoriteProductStore} from '@/store/favorite.product.store';
	import {computed} from 'vue';
	import {useAppStore} from '@/store/app.store';
	import {useFilters} from '@/store/filter.store';

	defineProps<{
		numberOfResults: number;
	}>();

	const emit = defineEmits(['update-overview']);

	const appStore = useAppStore();
	const filterStore = useFilters();
	const favoriteStore = useFavoriteProductStore();

	const favoriteViewActive = computed(() => favoriteStore.favoriteViewActive);

	const updateOverview = async () => emit('update-overview');

	const toggleFavoriteView = () => {
		if (!favoriteViewActive.value) {
			appStore.setFilterBlockActive(true);
		}

		favoriteStore.toggleFavoriteView();
		filterStore.resetFilters();

		updateOverview();
	};

</script>

<template>
	<FavoritesBackButton v-if="favoriteViewActive" @toggle-favorites="toggleFavoriteView" />

	<VarietyFiltersComponent v-else :number-of-results="numberOfResults" @filters-updated="updateOverview" />

	<slot></slot>
</template>
